module.exports = __webpack_public_path__ + "static/GFX_Learning-4d44ff5ffe743028da85e27fb7f58bba.png";